export default __webpack_public_path__ + "static/media/CarService.7b7a0912.webp";